module.exports = __webpack_public_path__ + "static/media/0003.f22ad32f.jpg";